import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { getUser } from "../utils";

const QUERY_KEY = "pricingFeatureFlags";

export function usePricingFeatureFlags() {
  const user = getUser();
  return useQuery({
    queryKey: [QUERY_KEY, user?.id],
    queryFn: () => api.getPricingFeatureFlags(user!.id).then((res) => res.data),
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });
}
